module.exports = __webpack_public_path__ + "static/img/confirmOrder.91090679.png";